import React from 'react';
import { Container, FlexProps, StackDirection, StackGap } from './Stack.styles';

type StackProps = {
  children: React.ReactNode;
  gap?: StackGap;
  direction?: StackDirection;
} & FlexProps;

export function Stack({ children, gap = 8, direction = 'vertical', ...flexProps }: StackProps) {
  return (
    <Container gap={gap} direction={direction} {...flexProps}>
      {children}
    </Container>
  );
}
